import { CASH_DESK_ACTION_TYPE } from "./cash-desk.action";

export const CASH_DESK_MESSAGE_CONTEXT = {
	get: CASH_DESK_ACTION_TYPE.get,
};
